'use strict';

module.exports = function (name) {
  if (!name) return name;

  name = name.split('__');
  name.shift();

  return name.join('__');
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-name.js
// module id = 1041
// module chunks = 0